define('modules/common/filter/notaPreview',[], function() {
	var Filter = function($filter) {

		return function(nota,max) {
			if (nota) {
				if (nota.length<max) {
					return nota;
				}
				var maxLength=max;
				var notaTagliata = nota.substr(0, maxLength);

				notaTagliata = notaTagliata.substr(0, Math.min(notaTagliata.length, notaTagliata.lastIndexOf(" ")));

				return notaTagliata + "...";

			} else {
				return "";
			}

		};

	};
	return ["$filter", Filter];
});
